const USER_DETAILS_STORE_KEY = "authDetails";

export interface UserDetailsStore {
    refreshToken: string,
    refreshTokenExpiry: number,
    accessToken: string,
    accessTokenExpiry: number,
    loggedInUser: UserDetails,
}

export interface UserDetails {
    id: string,
    email: string,
    firstName: string,
    lastName: string,
    active: boolean
}

let cachedUserDetails : UserDetailsStore | undefined;

function getUserDetails(): UserDetailsStore | undefined {
    if (cachedUserDetails) {
        return cachedUserDetails;
    }
    const currentStorageDetails = localStorage.getItem(USER_DETAILS_STORE_KEY);
    if (!currentStorageDetails) {
        return;
    } else {
        cachedUserDetails = JSON.parse(currentStorageDetails);
        return cachedUserDetails;
    }
}

function updateUserDetails(refreshToken: string, accessToken: string, userDetails: UserDetails) {
    cachedUserDetails = {
        refreshToken: refreshToken,
        refreshTokenExpiry: inferExpiry(refreshToken),
        accessToken: accessToken,
        accessTokenExpiry: inferExpiry(accessToken),
        loggedInUser: userDetails
    };
    localStorage.setItem(USER_DETAILS_STORE_KEY, JSON.stringify(cachedUserDetails))
}

function signOut() {
    cachedUserDetails = undefined;
    localStorage.removeItem(USER_DETAILS_STORE_KEY);
}

function inferExpiry(token: string) : number {
    const signedTokenParts : string[] = token.split(".");
    const payload = signedTokenParts[1];
    if (!payload) {
        return 0;
    }
    try {
        // Support both base64 and base64url JWT payloads
        let b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const pad = b64.length % 4;
        if (pad === 2) b64 += "==";
        else if (pad === 3) b64 += "=";
        const json = atob(b64);
        return JSON.parse(json).exp;
    } catch (_e) {
        // If parsing fails, treat as expired
        return 0;
    }
}


const LocalStorageService = {
    getUserDetails,
    updateUserDetails,
    signOut
}

export default LocalStorageService;